// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"prefooter_wrapper__M4DrZ","section":"prefooter_section__RkYkX","illustration":"prefooter_illustration__qk8r5","cta":"prefooter_cta__VAcYP","text":"prefooter_text__U9O92"};